import React, { useMemo } from 'react'
import { JiraFieldDefaultValueProps } from '../jira-field-default-value'
import { MultiSelectCombobox } from '../../../../../../legacy-design-system/combobox'

export const ArraysField = (props: JiraFieldDefaultValueProps) => {
  const { field, updateValue } = props

  const allowedValues = useMemo(
    () =>
      field._projectField?.allowedValues?.map(
        (allowedValue) => allowedValue.name
      ) ?? [],
    [field._projectField?.allowedValues]
  )

  const selectedValues = !field.value?.trim().length
    ? []
    : field.value?.split(',')

  const onSelectionChange = (event) => updateValue(event.join(','))

  return (
    <MultiSelectCombobox
      items={[
        {
          items: allowedValues ?? []
        }
      ]}
      label=""
      onChange={onSelectionChange}
      renderLabel={() => undefined}
      values={selectedValues}
    />
  )
}
